import { render } from "./SectionQueroSerCliente.vue?vue&type=template&id=7078b6d8&scoped=true"
import script from "./SectionQueroSerCliente.vue?vue&type=script&lang=js"
export * from "./SectionQueroSerCliente.vue?vue&type=script&lang=js"

import "./SectionQueroSerCliente.vue?vue&type=style&index=0&id=7078b6d8&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7078b6d8"]])

export default __exports__